import type { FunctionComponent, PropsWithChildren } from "react";

const MainContent: FunctionComponent<PropsWithChildren> = ({ children }) => (
  <div className="px-10 pt-7 pb-10 max-w-full">{children}</div>
);

export default MainContent;
